import { Component, Fragment } from 'react';

import { WebCategory } from '../../../../../../domain/model/category/WebCategory';
import ErrorBoundaryWrapChildren from '../../../../common/handler/ErrorBoundaryWrapChildren';
import { Page } from '../../../../common/store/interface/Page';
import ScrollRecorder from '../../../common/components/js/feedItems/ScrollRecorder';
import MainFrame from '../../../common/components/js/frames/MainFrame';
import SubFrame from '../../../common/components/js/frames/SubFrame';
import NoscriptAlert from '../../../common/components/js/modules/NoscriptAlert';
import YahooAnalytics from '../../../common/containers/modules/YahooAnalytics';
import UserBehaviorLoggerPageView from '../../../common/containers/modules/UserBehaviorLoggerPageView';
import CustomLogger from '../../../common/containers/modules/CustomLogger';
import SetMiffyBucket from '../../../common/containers/modules/SetMiffyBucket';
import YadsNormal from '../../../common/containers/modules/YadsNormal';
import YadsPremium from '../../../common/containers/modules/YadsPremium';
import CommentRanking from '../../../common/containers/ranking/CommentRanking';
import TextNewsRanking from '../../../common/containers/ranking/TextNewsRanking';
import TopBaseball from '../../containers/TopBaseball';
import TopHorseRacing from '../../containers/TopHorseRacing';
import MainColumnNotice from '../../containers/MainColumnNotice';
import NewsFeed from '../../containers/NewsFeed';
import NewsFeedLocalTab from '../../containers/NewsFeedLocalTab';
import NewsFeedTab from '../../containers/NewsFeedTab';
import TopSoccer from '../../containers/TopSoccer';
import SubColumnBottomNotice from '../../containers/SubColumnBottomNotice';
import SubColumnMiddleNotice from '../../containers/SubColumnMiddleNotice';
import SubColumnTopNotice from '../../containers/SubColumnTopNotice';
import Topics from '../../containers/Topics';
import ZasshiRanking from '../../containers/ZasshiRanking';
import BrowserBackLogger from '../../../common/components/js/modules/BrowserBackLogger';
import ScrollTopButtonWithFadeIn from '../../../common/components/js/modules/ScrollTopButtonWithFadeIn';

interface IProps {
  category?: WebCategory;
  subCategoryId?: string;
}

export default class CategoryContents extends Component<IProps> {
  /**
   *
   */
  public render(): JSX.Element {
    return (
      <Fragment>
        <ErrorBoundaryWrapChildren>
          <SetMiffyBucket />
        </ErrorBoundaryWrapChildren>
        <MainFrame>
          <NoscriptAlert />
          <MainColumnNotice />
          {this.props.category !== WebCategory.LIFE ? <Topics /> : null}
          {this.props.category !== WebCategory.LOCAL ? <NewsFeedTab /> : <NewsFeedLocalTab />}
          {this.props.category === WebCategory.SPORTS ? this.getSportsnaviModule(this.props.subCategoryId) : null}
          <NewsFeed />
        </MainFrame>
        <SubFrame>
          {/* LREC */}
          <YadsPremium
            ds="85285_187195"
            parentElement="yads_85285_187195"
            page={Page.TOP}
            minHeightForPreventLayoutShift="250"
            isMainColumn={false}
            isNoTopBorder={false}
            isWithMarginBottom={false}
          />
          <SubColumnTopNotice />
          <TextNewsRanking />
          <SubColumnMiddleNotice />
          <CommentRanking />
          {/* YDN */}
          <YadsNormal
            ds="61428_15361"
            parentElement="yads_61428_15361"
            page={Page.TOP}
            minHeightForPreventLayoutShift="250"
            isMainColumn={false}
            isNoTopBorder={false}
            isWithMarginBottom={false}
          />
          <SubColumnBottomNotice />
          <ZasshiRanking />
          {/* YDN */}
          <YadsNormal
            ds="61428_243519"
            parentElement="yads_61428_243519"
            page={Page.TOP}
            minHeightForPreventLayoutShift="250"
            isMainColumn={false}
            isNoTopBorder={false}
            isWithMarginBottom={false}
          />
        </SubFrame>
        <ScrollTopButtonWithFadeIn />
        <ErrorBoundaryWrapChildren>
          <ScrollRecorder />
          <BrowserBackLogger />
          <CustomLogger isEnabledViewable={true} />
          <UserBehaviorLoggerPageView />
          <YahooAnalytics />
        </ErrorBoundaryWrapChildren>
      </Fragment>
    );
  }

  private getSportsnaviModule(subCategoryId?: string): JSX.Element | null {
    switch (subCategoryId) {
      case 'new':
      case 'base':
        return <TopBaseball hasTitle={false} />;
      case 'socc':
        return <TopSoccer hasTitle={false} />;
      case 'horse':
        return <TopHorseRacing hasTitle={false} />;
      default:
        return null;
    }
  }
}
